export default {
  title: 'No conformidades',
  title_serviceOrder: 'No conformidades de actividades',
  title_formReply: 'No conformidades de formularios',
  question: 'Pregunta',
  place: 'Lugar',
  status: 'Estado',
  opened: 'Abierta',
  concluded: 'Concluida',
  instancesCount: 'Cant. ocurrencias',
  instances: '{{count}} ocurrencias',
  lastTime: 'Última vez {{time}}',
  actionPlans: 'Planes de acción',
  automations: 'Automatizaciones',
  integrations: 'Integraciones',
  moreOptions: 'Más opciones'
}
